// Glowie — scripts propios (mt-*). Vanilla JS, sin librerias externas.

function mtInitReveal() {
  var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
  if (!els.length) return;

  function revelar(el) {
    if (el.classList.contains('mt-visible')) return;
    var delay = el.getAttribute('data-mt-delay') || 0;
    setTimeout(function () {
      el.classList.add('mt-visible');
    }, Number(delay));
  }

  if (!('IntersectionObserver' in window)) {
    els.forEach(revelar);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          revelar(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });

  // Red de seguridad: si un scroll rapido o instantaneo (rueda, teclado,
  // enlace ancla) mueve un bloque de un extremo al otro del viewport sin
  // que el observer llegue a disparar, no debe quedar invisible para siempre.
  var pendiente = false;
  function revisarRezagados() {
    pendiente = false;
    document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        revelar(el);
        observer.unobserve(el);
      }
    });
  }
  function pedirRevision() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(revisarRezagados);
  }
  window.addEventListener('scroll', pedirRevision, { passive: true });
  window.addEventListener('resize', pedirRevision, { passive: true });
  pedirRevision();

  // Ultima red de seguridad: pase lo que pase (observer que nunca dispara,
  // bloque fuera de cualquier caso previsto), nada debe quedar invisible
  // para siempre. A los 4s se fuerza la aparicion de lo que quede.
  setTimeout(function () {
    document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
      revelar(el);
      observer.unobserve(el);
    });
  }, 4000);
}

function mtInitComparador() {
  document.querySelectorAll('.mt-comparador').forEach(function (wrap) {
    var handle = wrap.querySelector('.mt-comparador__asa');
    var beforeEl = wrap.querySelector('.mt-comparador__antes');
    if (!handle || !beforeEl) return;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pos = ((clientX - rect.left) / rect.width) * 100;
      pos = Math.max(0, Math.min(100, pos));
      beforeEl.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
      handle.style.left = pos + '%';
    }

    var dragging = false;
    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointerup', function () { dragging = false; });
    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(e.clientX);
    });
    wrap.addEventListener('click', function (e) {
      if (e.target === handle) return;
      setPos(e.clientX);
    });
    handle.addEventListener('keydown', function (e) {
      var rect = wrap.getBoundingClientRect();
      var current = parseFloat(handle.style.left) || 50;
      if (e.key === 'ArrowLeft') setPos(rect.left + (rect.width * (current - 5)) / 100);
      if (e.key === 'ArrowRight') setPos(rect.left + (rect.width * (current + 5)) / 100);
    });
  });
}

function mtInitGaleriaProducto() {
  document.querySelectorAll('.mt-producto-galeria').forEach(function (galeria) {
    var principal = galeria.querySelector('.mt-producto-galeria__principal img');
    var minis = galeria.querySelectorAll('.mt-producto-galeria__mini');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-full');
        var alt = mini.getAttribute('data-alt') || '';
        if (!full) return;
        principal.src = full;
        principal.alt = alt;
        minis.forEach(function (m) { m.classList.remove('mt-producto-galeria__mini--activa'); });
        mini.classList.add('mt-producto-galeria__mini--activa');
      });
    });
  });
}

function mtInitVariantesProducto() {
  document.querySelectorAll('.mt-producto-form').forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var selects = form.querySelectorAll('[data-mt-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var comparadoEl = form.querySelector('[data-mt-precio-comparado]');
    var botonEl = form.querySelector('[data-mt-boton-comprar]');
    if (!selects.length || !idInput) return;

    function variantePorOpciones() {
      var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
    }

    function actualizar() {
      var variante = variantePorOpciones();
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl && variante.price_formatted) precioEl.textContent = variante.price_formatted;
      if (comparadoEl) {
        if (variante.compare_at_price_formatted) {
          comparadoEl.textContent = variante.compare_at_price_formatted;
          comparadoEl.style.display = '';
        } else {
          comparadoEl.style.display = 'none';
        }
      }
      if (botonEl) {
        if (variante.available) {
          botonEl.disabled = false;
          botonEl.textContent = botonEl.getAttribute('data-mt-texto-disponible');
        } else {
          botonEl.disabled = true;
          botonEl.textContent = botonEl.getAttribute('data-mt-texto-agotado');
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveal();
  mtInitComparador();
  mtInitGaleriaProducto();
  mtInitVariantesProducto();
});
